
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from './CartProvider';
import CartDrawer from './CartDrawer';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [hasOrders, setHasOrders] = useState(false);
  const { state } = useCart();

  // Check if user has any orders
  useEffect(() => {
    const checkOrders = () => {
      try {
        const orders = JSON.parse(localStorage.getItem('customerOrders') || '[]');
        setHasOrders(orders.length > 0);
      } catch (error) {
        setHasOrders(false);
      }
    };

    checkOrders();
    // Listen for storage changes (in case orders are added from another tab)
    window.addEventListener('storage', checkOrders);
    // Custom event for same-tab updates
    window.addEventListener('ordersUpdated', checkOrders);

    return () => {
      window.removeEventListener('storage', checkOrders);
      window.removeEventListener('ordersUpdated', checkOrders);
    };
  }, []);

  return ( 
    <>
      <header className="sticky top-0 z-50 bg-white shadow-sm border-b border-green-100">
        <div className="w-full px-4 sm:px-6 py-3 sm:py-4">
          <div className="flex items-center justify-between">
           <Link to="/" className="flex items-center space-x-2 flex-shrink-0" aria-label="Nirvana Ayurveda - Homepage">
<img 
  src="/ayur.jpg" 
  alt="Nirvana Ayurveda - Natural Health Solutions Logo" 
  className="w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 object-contain"
/>
 <h2 className="m-0 text-base sm:text-lg md:text-xl lg:text-2xl font-pacifico text-green-700 leading-tight">
    Nirvana AyurVeda
  </h2>
</Link>

            <nav className="hidden lg:flex items-center space-x-6 xl:space-x-8">
              <Link to="/" className="text-gray-700 hover:text-green-600 transition-colors">
                Home
              </Link>
              <Link to="/products" className="text-gray-700 hover:text-green-600 transition-colors">
                Products
              </Link>
              <Link to="/about" className="text-gray-700 hover:text-green-600 transition-colors">
                About Us
              </Link>
              <Link to="/contact" className="text-gray-700 hover:text-green-600 transition-colors">
                Contact
              </Link>
              {hasOrders && (
                <Link to="/my-orders" className="text-gray-700 hover:text-green-600 transition-colors">
                  My Orders
                </Link>
              )}
              <button onClick={() => setIsCartOpen(true)} className="relative cursor-pointer p-2 -mr-2">
                <i className="ri-shopping-cart-line text-xl text-gray-700 hover:text-green-600 transition-colors"></i>
                {state.itemCount > 0 && (
                  <span className="absolute -top-1 -right-1 bg-green-600 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-medium">
                    {state.itemCount}
                  </span>
                )}
              </button>
            </nav>

            {/* <div className="hidden md:flex items-center space-x-4">
              <Link to="/login" className="text-gray-700 hover:text-green-600 transition-colors">
                Login
              </Link>
              <Link to="/signup" className="bg-green-600 text-white px-4 py-2 rounded-full hover:bg-green-700 transition-colors whitespace-nowrap">
                Sign Up
              </Link>
            </div> */}

            <div className="flex items-center space-x-3 lg:hidden">
              <button onClick={() => setIsCartOpen(true)} className="relative cursor-pointer p-2">
                <i className="ri-shopping-cart-line text-xl text-gray-700 hover:text-green-600 transition-colors"></i>
                {state.itemCount > 0 && (
                  <span className="absolute -top-1 -right-1 bg-green-600 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-medium">
                    {state.itemCount}
                  </span>
                )}
              </button>
              <button 
                className="p-2 -mr-2"
                onClick={() => setIsMenuOpen(!isMenuOpen)}
              >
                <i className="ri-menu-line text-2xl text-gray-700"></i>
              </button>
            </div>
          </div>

          {isMenuOpen && (
            <div className="lg:hidden mt-4 pb-4 border-t border-green-100">
              <div className="flex flex-col space-y-3 pt-4">
                <Link to="/" className="text-gray-700 hover:text-green-600 transition-colors">
                  Home
                </Link>
                <Link to="/products" className="text-gray-700 hover:text-green-600 transition-colors">
                  Products
                </Link>
                <Link to="/about" className="text-gray-700 hover:text-green-600 transition-colors">
                  About Us
                </Link>
                <Link to="/contact" className="text-gray-700 hover:text-green-600 transition-colors">
                  Contact
                </Link>
                {hasOrders && (
                  <Link to="/my-orders" className="text-gray-700 hover:text-green-600 transition-colors">
                    My Orders
                  </Link>
                )}
                <div className="pt-2 border-t border-green-100">
                  <button onClick={() => setIsCartOpen(true)} className="flex items-center space-x-2 text-gray-700 hover:text-green-600 transition-colors">
                    <i className="ri-shopping-cart-line text-xl"></i>
                    <span>Cart ({state.itemCount})</span>
                  </button>
                </div>
                {/* <Link to="/login" className="text-gray-700 hover:text-green-600 transition-colors">
                  Login
                </Link>
                <Link to="/signup" className="bg-green-600 text-white px-4 py-2 rounded-full hover:bg-green-700 transition-colors whitespace-nowrap w-fit">
                  Sign Up
                </Link> */}
              </div>
            </div>
          )}
        </div>
      </header>
      
      <CartDrawer isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} />
    </>
  );
}
